import { Reducer } from 'redux';
import { TOGGLE_CAMERA } from '../actions';

export interface ICameraState {
  mounted: boolean;
}
const cameraInitialState: ICameraState = {
  mounted: false,
};

const telemetryReducer: Reducer<ICameraState> = (
  state = cameraInitialState,
  { type, payload },
) => {
  switch (type) {
    case TOGGLE_CAMERA:
      return {
        ...state,
        mounted: payload,
      };

    default:
      return state;
  }
};

export default telemetryReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/cameraReducer.ts